import Swal from "sweetalert2";

//Possible Types: [success, error, warning, info, question]
//Usage --> //showToast('success', 'Hogya')
export const showToast = (type, message) => {
  Swal.fire({
    icon: type,
    title: message,
    showConfirmButton: false,
    timerProgressBar: true,
    timer: 2000,
    customClass: {
      popup: 'swal-toast-style',
      // title: 'swal-toast-style-title'
    }
  });
};

export const showConfirmMessage = async () => {
  const confirmed = await Swal.fire({
    // title: 'Confirmation',
    text: 'Are you sure you want to Delete it?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes Delete it!',
    cancelButtonText: 'No',
    customClass: {
      popup: 'swal-toast-style',
      title: 'swal-title-small'
    }
  });
  return confirmed.isConfirmed;
};

export const showCustomConfirmMessage = async ({ message, icon }) => {
  const confirmed = await Swal.fire({
    // title: 'Confirmation',
    text: message ?? "Confirmation Message",
    icon: icon ?? "warning",
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    customClass: {
      popup: 'swal-toast-style',
      title: 'swal-title-small'
    }
  });
  return confirmed.isConfirmed;
};

export const showDeleteOrRestoreMessage = async (type) => {
  const actionType = type || "Delete";
  const isDelete = actionType === "Delete";
  const isRestore = actionType === "Restore";
  const confirmed = await Swal.fire({
    //   title: 'Confirmation',
    text: `Are you sure you want to ${actionType} it?`,
    icon: isDelete ? "warning" : (isRestore ? "info" : "warning"),
    showCancelButton: true,
    confirmButtonColor: isDelete ? '#d33' : '#28a745',
    cancelButtonColor: '#6c757d',
    confirmButtonText: `Yes, ${actionType} it!`,
    cancelButtonText: 'No',
    customClass: {
      popup: 'swal-toast-style',
      title: 'swal-title-small'
    }
  });

  return confirmed.isConfirmed;
};

export const showAddUpdateConfirm = async (msg) => {
  const allow = await Swal.fire({
    title: msg,
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Save",
    customClass: {
      popup: 'swal-toast-style',
      title: 'swal-title-small'
    }
  })
  return allow.isConfirmed
}

export const showTokenExpiryPopUp = async () => {
  const Confirmation = await Swal.fire({
    title: 'Timeout',
    text: 'Session expired. Please log in again',
    icon: 'warning',
    showCancelButton: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false,
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Logout Now',
    customClass: {
      popup: 'swal-toast-style',
      title: 'swal-title-small'
    }
  })
  return Confirmation.isConfirmed;
}

//Usage --> Toast.fire({ icon: 'success', title:"xx", customClass: {popup: 'custom-toast-class' }});
export const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
  customClass: {
    popup: 'swal-toast-style',
    title: 'swal-title-small'
  }
});